import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listings: {},
  loading: false,
  error: null,
};

export const dragColumnSettingsSlice = createSlice({
  name: "dragColumnSettings",
  initialState,
  reducers: {
    startCall: (state) => {
      state.loading = true;
      state.error = null;
    },
    columnListingStored: (state, action) => {
      const { entity, columns, settingsKey } = action.payload;
      state.listings[settingsKey] = entity?.selectedColumns ? entity : { selectedColumns: columns };
      state.loading = false;
    },
    catchError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
